import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { ReplaceGymMemberMembershipCard, getProducts } from "../../redux/actions/api/apiAction";
export const SaleProductCard = ({ showModal, toggle ,values,newRFIDCardIdValue}) => {
  const dispatch = useDispatch();
  const [product, setProduct] = useState(null);
  const [paymentType, setPaymentType] = useState(null);

  const { availableProducts } = useSelector((state) => state.product);
  const { loading } = useSelector((state) => state.gym);
  const handleReturn = () => {
 
    dispatch(
      ReplaceGymMemberMembershipCard(
        values.id,
        values.cardMembershipId,
        newRFIDCardIdValue,
        product.id,
        paymentType,
      )
    );
    toggle();
  };
  React.useEffect(() => {
    /** here will get the product */
    dispatch(
      getProducts({
        limit: 999999999999999,
        page: 1,
        search: "card",
        availablQuantity: true,
      })
    );
  }, []);
  React.useEffect(() => {
    /** here will get the product */
    if (!availableProducts.length || availableProducts.length > 1) {
      setProduct(null);
    } else {
      setProduct(availableProducts[0]);
    }
  }, [availableProducts]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
  return (
    <>
      <Modal
        isOpen={showModal}
        toggle={toggle}
        centered={true}
        size="lg"
        className="large-pop adding-popup "
      >
        <ModalHeader toggle={toggle}>Sale Card</ModalHeader>
        <ModalBody>
          {product ? (
            <>
              <div className="bg-white mx-2">
                <div className="appointment-info-container p-2">
                  <div className="appointment-info-container p-2">
                    <Row className="pb-2">
                      <Col xs={4}>
                        <span className="appointment-info-titles">
                          Product Name:
                        </span>
                      </Col>
                      <Col xs={4}>
                        <span className="appointment-info-titles">
                          Available in Stock
                        </span>
                      </Col>
                      <Col xs={4}>
                        <span className="appointment-info-titles">Price </span>
                      </Col>
                    </Row>

                    <Row>
                      {" "}
                      <Col xs={4}>
                        <span className="appointment-info-bold">
                          {product.name}
                        </span>
                      </Col>
                      <Col xs={4}>
                        <span className="appointment-info-bold">
                          {product.availableInStock}
                        </span>
                      </Col>
                      <Col xs={4}>
                        <span className="appointment-info-bold">
                          {product.price}
                        </span>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y ml-2">
                  <div className="status-inner-block">
                    <div className="status-inner-block">
                      <Row>
                        <Col md={3}>
                          <div
                            className="form-check form-check-inline custom-btn-radio"
                            checked
                          >
                            <Input
                              type="radio"
                              name="paymentType"
                              id="cash"
                              value="L"
                              className="form-check-input"
                              onChange={(e) => setPaymentType(e.target.value)}
                            />

                            <label
                              className="form-check-label label-blk"
                              style={{ fontSize: "15px" }}
                              for="cash"
                            >
                              Cash
                            </label>
                          </div>
                        </Col>

                        <Col md={3}>
                          <Input
                            type="radio"
                            name="paymentType"
                            id="visa"
                            value="CC"
                            className="form-check-input"
                            onChange={(e) => setPaymentType(e.target.value)}
                          />

                          <label
                            className="form-check-label label-blk"
                            style={{ fontSize: "15px" }}
                            for="visa"
                          >
                            Visa/MC
                          </label>
                        </Col>
                        <Col md={3}>
                          <Input
                            type="radio"
                            name="paymentType"
                            id="bank"
                            value="BA"
                            className="form-check-input"
                            onChange={(e) => setPaymentType(e.target.value)}
                          />
                          <label
                            className="form-check-label label-blk complementary-radio-add-sale"
                            style={{ fontSize: "15px" }}
                            for="bank"
                          >
                            Bank
                          </label>
                        </Col>
                        <Col md={3}>
                          <Input
                            type="radio"
                            name="paymentType"
                            id="comp"
                            value="CO"
                            className="form-check-input"
                            onChange={(e) => setPaymentType(e.target.value)}
                          />
                          <label
                            className="form-check-label label-blk complementary-radio-add-sale"
                            style={{ fontSize: "15px" }}
                            for="comp"
                          >
                            Complimentary
                          </label>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              <Row className="mx-0 w-100">
                <Col md={12} className="px-0">
                  <div className="action-wrapper blk-padding-y d-flex justify-content-between minimize-btns">
                    <div className="action-inner-block d-flex justify-content-between w-100">
                      <React.Fragment>
                        <button
                          type="button"
                          className="btn btn-medium btn-transparent mr-4"
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Cancel
                        </button>
                      </React.Fragment>
                      <button
                        className="btn btn-medium min-width-210"
                        type="button"
                        onClick={() => {
                          handleReturn();
                        }}
                      >
                        Replace
                      </button>{" "}
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          ) : (
            <h3>There is no product for cards</h3>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};
